﻿export interface IInsuranceDetails {
    primaryGroupId: number;
    primaryGroupName: string;
    primaryDetails: string;
    secondaryGroupId: number;
    secondaryGroupName: string;
    secondaryDetails: string;
    relationshipToSubscriber: string;
    globalCaseRate: boolean;
    precertificationPhone: string;
    professionalCaseRate: boolean;
    benefitPhone: string;
    caseManagerName: string;
    caseManagerPhone: string;
    financialComments: string;
    patientName: string;
    subscriberName: string;
    policyIdNumber: string;
    groupNumber: string;
    healthPlanName: string;
    claimsMailingAddress: string;
    isMedicarePostTransplant: boolean;
    medicareNumber: string;
    hasMedicareAB: boolean;
    isPrimaryPrivate: boolean;
    isSecondaryPrivate: boolean;
    isInsuranceComplete: boolean;
}
